"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsetRow = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../helpers");
const FieldsetRow_styles_1 = require("./FieldsetRow.styles");
exports.FieldsetRow = react_1.default.memo(function FieldsetRow({ className, label, value, labelWidth, wordBreak, transform }) {
    return (react_1.default.createElement(FieldsetRow_styles_1.StyledFieldsetRow, { wordBreak: wordBreak, labelWidth: labelWidth, className: (0, helpers_1.cn)('vm-WizardSummaryRow', className) },
        react_1.default.createElement("td", null, label),
        react_1.default.createElement("td", null, transform ? transform(value) : value)));
});
//# sourceMappingURL=FieldsetRow.js.map